import { render, staticRenderFns } from "./ActionGiftInfo.vue?vue&type=template&id=3057b8d1&scoped=true"
import script from "./ActionGiftInfo.vue?vue&type=script&lang=js"
export * from "./ActionGiftInfo.vue?vue&type=script&lang=js"
import style0 from "./ActionGiftInfo.vue?vue&type=style&index=0&id=3057b8d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057b8d1",
  null
  
)

export default component.exports